export const barChartOptions = {
  maintainAspectRatio: false,
  aspectRatio: 0.8,
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: true,
      color: "black",
      font: {
        size: 12,
        weight: "bold",
      },
    },
  },
  scales: {
    x: {
      ticks: {
        color: "brown",
        font: {
          weight: 500,
        },
      },
      grid: {
        display: false,
        drawBorder: false,
      },
    },
    y: {
      ticks: {
        color: "brown",
      },
      grid: {
        color: "lightgray",
        drawBorder: false,
      },
    },
  },
};

export const pieChartOptions = {
  plugins: {
    datalabels: {
      display: true,
      color: "black",
      font: {
        size: 12,
        weight: "bold",
      },
    },
  },
};

export const cfstConstants = {
  cfst: "cfst",
  nonCfst: "nonCfst",
  defaultMMDDYYYY: "MM/DD/YYYY",
  defaultYYYYMMDD: "YYYY-MM-DD",
  dateSplits: {
    days: "days",
    months: "months",
    years: "years",
  },
  tillDateValue: "tillDate",
  tillDateOption: "till_date",
  fromTime: "00:00:00",
  toTime: "23:59:59",
  countRequestForComparisonView: "ComparisonView",
  countRequestForDeReCasesCount: "DeReCasesCount",
  countRequestForCountsView: "CountsView",
  onlineSchedulesHeading: "Online Schedules",
  offlineSchedulesHeading: "Offline Schedules",
};